import $ from 'jquery';

export default function Infographic() {
    $(function () {
        $(".infographic-click").on("click", function (e) {
            $(".infographic-click").removeClass("active");
            $(".data-box").removeClass("active");
            $(this).addClass("active");
            $(this.attributes["data-value"].value).addClass("active");
        });
        $(".js-link-plus").on("click", function (e) {
            e.preventDefault();

            $(".infographic-data").removeClass("active");
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).html("+");
            }
            else {
                $(".js-link-plus").removeClass("active");
                $(".js-link-plus").html("+");
                $(this).addClass("active");
                $(this).html("-");
                $(this.attributes["data-value"].value).addClass("active");
            }
        });
    })

};
